import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { prototypingPageMeta, prototypingSchema } from 'components/common/schema'
import Template from 'components/services/prototyping'

const Prototyping: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...prototypingPageMeta} />
      <JsonLd data={prototypingSchema} />
      <Template />
    </>
  )
}

export default Prototyping
